const TYPESENGINEERS: {
  label: string;
  href: string;
}[] = [
  {
    label: 'All',
    href: '/engineers/the-remote-engineer',
  },
  {
    label: 'Blog posts',
    href: '/engineers/blog',
  },
  {
    label: 'Guides',
    href: '/engineers/guides',
  },
  {
    label: 'The Global Engineer',
    href: '/engineers/the-global-engineer/archive',
  },
  // {
  //   label: 'Webinars',
  //   href: '/engineers/webinars',
  // },
  {
    label: 'Videos',
    href: '/engineers/videos',
  },
];

export default TYPESENGINEERS;
